const comments = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20avatar%20portrait%2C%20friendly%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style%2C%20warm%20tone&width=80&height=80&seq=qinqin-avatar-01&orientation=squarish',
    text: '亲亲漫画真的是我用过最好用的免费漫画平台！韩漫、日漫、国漫资源超全，下拉式阅读体验太流畅了，每天必刷的漫画大全！',
    time: '2天前',
  },
  {
    name: '追漫少女小樱',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20avatar%20portrait%2C%20gentle%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style%2C%20warm%20tone&width=80&height=80&seq=qinqin-avatar-02&orientation=squarish',
    text: '自从发现了亲亲漫画，再也不用到处找资源了。热门推荐每天更新，完结漫画也能免费全集在线看，好看的漫画根本停不下来！',
    time: '3天前',
  },
  {
    name: '日漫爱好者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20avatar%20portrait%2C%20casual%20style%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style%2C%20warm%20tone&width=80&height=80&seq=qinqin-avatar-03&orientation=squarish',
    text: '作为一个重度日漫迷，亲亲漫画的更新速度真的很赞！热门连载基本当天就能看到最新话，而且完全免费，良心平台强烈推荐。',
    time: '5天前',
  },
  {
    name: '国漫铁粉小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20avatar%20portrait%2C%20bright%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style%2C%20warm%20tone&width=80&height=80&seq=qinqin-avatar-04&orientation=squarish',
    text: '国漫这几年越来越好了！亲亲漫画收录了很多优质国漫作品，古风修仙类的画风特别精美，免费全集下拉式阅读体验超棒！',
    time: '6天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          读者评价
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100/50 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}